import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, ToggleButton, ToggleButtonGroup, Box, Alert } from '@mui/material';

export default function FinanceAddItemDialog({ open, onClose, onSubmit, initialItem, itemsCount = 0 }) {
  const [type, setType] = useState(1);
  const [description, setDescription] = useState('');
  const [value, setValue] = useState('');
  const [valueType, setValueType] = useState(1);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialItem) {
      setType(initialItem.type);
      setDescription(initialItem.description);
      setValue(initialItem.value.toString());
      setValueType(initialItem.valueType);
    } else {
      setType(1);
      setDescription('');
      setValue('');
      setValueType(1);
      setErrors({});
    }
  }, [initialItem, open]);

  const validate = () => {
    const newErrors = {};
    if (!description.trim()) newErrors.description = 'Descrição obrigatória';
    if (!value || parseFloat(value) <= 0) newErrors.value = 'Valor deve ser > 0';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSubmit({
      id: initialItem?.id ?? null,
      type,
      description: description.trim(),
      value: parseFloat(value),
      valueType,
      displayOrder: itemsCount,
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Adicionar Item</DialogTitle>
      <DialogContent sx={{ pt: 2 }} >
        <TextField
          select
          fullWidth
          label="Tipo"
          value={type}
          onChange={(e) => setType(e.target.value)}
          sx={{ mb: 2 }}
        >
          <MenuItem value={1}>Adicional</MenuItem>
          <MenuItem value={2}>Desconto</MenuItem>
          <MenuItem value={3}>Taxa</MenuItem>
        </TextField>

        <TextField
          fullWidth
          label="Descrição"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          error={!!errors.description}
          helperText={errors.description}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          type="number"
          label="Valor"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          error={!!errors.value}
          helperText={errors.value}
          inputProps={{ step: '0.01' }}
          sx={{ mb: 2 }}
        />

        <Box sx={{ mb: 2 }}>
          <ToggleButtonGroup
            fullWidth
            exclusive
            value={valueType}
            onChange={(e, v) => v !== null && setValueType(v)}
          >
            <ToggleButton value={1}>R$</ToggleButton>
            <ToggleButton value={2}>%</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        {valueType === 2 && value && parseFloat(value) > 100 && (
          <Alert severity="warning">Percentual > 100% pode resultar em valores negativos</Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleSubmit}>Adicionar</Button>
      </DialogActions>
    </Dialog>
  );
}
